<template>
  <BudDialog class="lottery-detail-dialog" :showDialog="dialogVisible" @close-dialog="onCloseDialog">
    <div class="text-center">
      <h3>{{ $t('lottery_list.detail') }}</h3>
      <div class="dialog-header text-sm" :class="$i18n.locale">
        <div v-if="detail.action === 'draw'" class="lottery-prompt-text">
          {{ $t('lottery_list.prompt') }}
        </div>
        <div v-if="detail.status === 2">
          {{ $t('lottery_list.winner_prompt', detail.lucky_draw) }}
          <br>
          {{ $t('lottery_list.contact_staff') }}
        </div>
      </div>
      <div class="dialog-code-text pb-4">{{ $t('lottery_list.label_code', { code: detail.code }) }}</div>
      <div class="text-sm" :style="getStatusColor(detail)">{{ $t('lottery_list.label_status', { status: getStatusTitle(detail) }) }}</div>
<!--      <div class="text-sm text-white-600">-->
<!--        <div v-if="!detail.status">{{ $t('lottery_list.lottery_past', { date: detail.lucky_draw.end_date }) }}</div>-->
<!--        <div v-else>{{ $t('lottery_list.lottery_future', { date: detail.lucky_draw.end_date }) }}</div>-->
<!--      </div>-->
    </div>
  </BudDialog>
</template>

<script>
import lotteryMixin from '../helpers/lotteryMixin'
import BudDialog from '../components/BudDialog'

export default {
  mixins: [
    lotteryMixin
  ],
  components: {
    BudDialog
  },
  data() {
    return {
      dialogVisible: false,
      detail: {
        status: 0,
        lucky_draw: {}
      }
    }
  },
  methods: {
    show(data) {
      this.detail = data;
      this.dialogVisible = true;
    },
    onCloseDialog() {
      this.dialogVisible = false;
      this.$emit('input', false);
    }
  }
}
</script>

<style lang="scss">
  .lottery-detail-dialog {
    min-height: 400px;
    .dialog-header {
      padding: 1.25rem;
      height: 6.25rem;
      color: #F8C11C;
      line-height: 1.25rem;
      &.en {
        height: 7rem;
      }
      .text-orange {
        color: #ff8800;
      }
    }
    .dialog-code-text {
      font-size: 1.5rem;
    }
  }
</style>
